export function AgeConfirmTerms() {
  return (
    <div className="prose max-w-3xl mx-auto py-12 px-4">
      <h1>만 14세 이상 확인 약관</h1>
      <p>
        정보통신망 이용촉진 및 정보보호 등에 관한 법률 제31조에 따라,
        만 14세 미만 아동의 개인정보를 수집하려면 법정대리인의 동의가 필요합니다.
      </p>
      <p>
        A-Blind는 만 14세 이상 사용자만 가입 및 이용이 가능하며, 만 14세 미만이 가입한 경우 서비스 이용이 제한될 수 있습니다.
      </p>
      <p>본인은 만 14세 이상임을 확인하며 이에 동의합니다.</p>
    </div>
  );
}